// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "2f26baabc516c317","396": "d00aa1fa806a62c6","460": "36a391f0ac9ead3a","498": "8518b86e7aae010e","917": "fbcc5a5088131800","985": "941afe7523e55f10",}[chunkId] + ".chunk.js"
}